import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia'; // Import createPinia function

const pinia = createPinia(); // Create Pinia instance

createApp(App)
  .use(pinia) // Use Pinia instance
  .mount('#app');
